import { useEffect, useState } from "react";
import { CustomDialog } from "../../../../../../../../../components/dialog/v1/CustomDialog";
import { usePurchaseInfosValueContextHook } from "../../../../../../contexts/PurchaseInfosContext";
import { useStockCycleDatasValueContextHook } from "../../../../../../contexts/StockCycleDatasContext";
import styled from 'styled-components';
import { CustomLabelInput } from "../../../../../../../../../components/input/CustomLabelInput";
import CustomBlockButton from "../../../../../../../../../components/button/CustomBlockButton";
import { v4 as uuidv4 } from 'uuid';
import { useCreatePurchaseInfoMutation } from "../../../../../../Data/purchaseInfosReactQuery/PurchaseInfosReactQuery";
import { ProductOptionsApi } from "../../../../../../../../../apis/ProductOptionsApi";
import { SellertoolSignatureUtils } from "../../../../../../../../../utils/sellertool-signature-utils";
import { useApiInfoContextValueHook } from "../../../../../../../../../contexts/ApiInfoContext";

const StyledBody = styled.div`
    padding: 10px;

`;

const StyledWrapper = styled.div`
    form{
        display: flex;
        flex-direction: column;
        gap: 10px;
        .input-box{
            input{
                border-color: #efefef;
                background: #fff;
                border-radius: 5px;
                &:focus{
                    border-color: #333;
                }
            }
        }

        button{
            border-radius: 5px;
            border:none;
            background: #333;
            color: #fff;
        }
    }
    
`;

const StyledProductList = styled.div`

`;

const StyledProduct = styled.div`
    h4{
        font-size: 14px;
        font-weight: 600;
        margin-bottom: 5px;
    }

    .purchase-infos{
        margin-top: 10px;
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        gap: 5px;

        .purchase-info{
            display: flex;
            flex-direction: row;
            align-items: center;
            gap: 10px;
            border: 1px solid #efefef;
            background: #fff;
            padding: 8px 10px;
            border-radius: 6px;
            cursor: pointer;

            &:hover{
                box-shadow: var(--shadow-sm);
            }

            .badge{
                background: #f1f5f9;
                color: #334155;
                font-size: 11px;
                padding: 4px 8px;
                border-radius: 20px;
                font-weight: 600;
                display: inline-flex;
                align-items: center;
                gap: 4px;
        
                &.route{
                    background: #eef2ff;
                    color: #3730a3;
                }
    
                &.memo{
                    font-size: 11px;
                    background: #fff8e1;
                    color: #8a6d00;
                    padding: 3px 8px;
                    border-radius: 4px;
                    line-height: 1.3;
                }
            }
        }

    
    }

`;

function sortDataByProductName(data) {
    // 원본 배열을 변경하지 않기 위해 slice()로 복사본을 만듭니다.
    const sortedData = data.slice();

    sortedData.sort((a, b) => {
        const nameA = a.productDto.name + a.productOptionDto.name;
        const nameB = b.productDto.name + b.productOptionDto.name;

        // localeCompare를 사용하여 문자열을 비교합니다.
        // 이는 한국어, 대소문자, 특수문자 등을 올바르게 처리하는 데 도움을 줍니다.
        return nameA.localeCompare(nameB);
    });

    return sortedData;
}

export function FragmentLoad({
    setViewType,
    onClose,
    productOptionDetail,
    PURCHASE_ROUTE_OPTIONS
}) {
    const apiInfoContextValueHook = useApiInfoContextValueHook();

    const [relatedProductOptionProjections, setRelatedProductOptionProjections] = useState([]);

    const [searchText, setSearchText] = useState('');
    const [searchedProductOptionProjections, setSearchedProductOptionProjections] = useState([]);

    useEffect(() => {
        async function fetchRelatedProductOptionProjections() {
            const timestamp = Date.now().toString();
            const signature = SellertoolSignatureUtils().generateSigniture({
                apiKey: apiInfoContextValueHook?.apiInfo?.apiKey,
                secretKey: apiInfoContextValueHook?.apiInfo?.secretKey,
                timestamp: timestamp
            })

            const headers = {
                'x-sellertool-apiKey': apiInfoContextValueHook?.apiInfo?.apiKey,
                'x-sellertool-timestamp': timestamp,
                'x-sellertool-signiture': signature
            }
            const res = await ProductOptionsApi().searchRelatedProductOptionProjections({
                params: {
                    productOptionId: productOptionDetail?.productOptionDto?.id
                },
                headers: headers
            });

            if (res?.data?.content) {
                setRelatedProductOptionProjections(res?.data?.content);
            }
        }
        fetchRelatedProductOptionProjections();
    }, [productOptionDetail?.productOptionDto?.id]);

    const handleSearch = async () => {

        if (searchText?.trim() === '') {
            setSearchedProductOptionProjections([]);
            return;
        }

        const timestamp = Date.now().toString();
        const signature = SellertoolSignatureUtils().generateSigniture({
            apiKey: apiInfoContextValueHook?.apiInfo?.apiKey,
            secretKey: apiInfoContextValueHook?.apiInfo?.secretKey,
            timestamp: timestamp
        })

        const headers = {
            'x-sellertool-apiKey': apiInfoContextValueHook?.apiInfo?.apiKey,
            'x-sellertool-timestamp': timestamp,
            'x-sellertool-signiture': signature
        }

        const res = await ProductOptionsApi().searchProductOptionProjectionsByKeywords({
            params: {
                keywords: searchText
            },
            headers: headers
        });

        if (res?.data?.content) {
            setSearchedProductOptionProjections(sortDataByProductName(res?.data?.content));
        }
    }

    return (
        <>
            <CustomDialog.Header style={{ padding: 10 }}>
                <CustomDialog.Header.Back onClick={() => setViewType('DEFAULT')} />
                <CustomDialog.Header.Title>
                    <div className='text-center'>
                        <span>구매정보</span>
                        <div className='font-extrabold text-lg mt-1'>
                            {productOptionDetail?.productDto?.name} / {productOptionDetail?.productOptionDto?.name}
                        </div>
                    </div>
                </CustomDialog.Header.Title>
                <CustomDialog.Header.Close onClick={() => onClose()} />
            </CustomDialog.Header>
            <StyledBody>
                <StyledWrapper>
                    <h3># 연관 상품 구매정보</h3>
                    <StyledProductList>
                        {relatedProductOptionProjections?.map(rpod => (
                            <ProductComponent
                                key={rpod?.productOptionDto?.id}
                                productOptionDetail={productOptionDetail}
                                relatedProductOptionDetail={rpod}
                                PURCHASE_ROUTE_OPTIONS={PURCHASE_ROUTE_OPTIONS}
                                setViewType={setViewType}
                            />
                        ))}
                    </StyledProductList>
                </StyledWrapper>
                <StyledWrapper>
                    <h3># 검색으로 찾기</h3>
                    <form
                        onSubmit={(e) => {
                            e.preventDefault();
                            handleSearch();
                        }}
                    >
                        <CustomLabelInput className='input-box'>
                            <CustomLabelInput.Input
                                type='text'
                                value={searchText}
                                onChange={(e) => setSearchText(e.target.value)}
                            />
                            <CustomLabelInput.Label>상품명 또는 옵션명 &&로 구분</CustomLabelInput.Label>
                        </CustomLabelInput>
                        <CustomBlockButton
                            type='submit'
                        >
                            검색
                        </CustomBlockButton>
                    </form>
                    <StyledProductList>
                        {searchedProductOptionProjections?.map(rpod => (
                            <ProductComponent
                                key={rpod?.productOptionDto?.id}
                                productOptionDetail={productOptionDetail}
                                relatedProductOptionDetail={rpod}
                                PURCHASE_ROUTE_OPTIONS={PURCHASE_ROUTE_OPTIONS}
                                setViewType={setViewType}
                            />
                        ))}
                    </StyledProductList>
                </StyledWrapper>
            </StyledBody>
        </>
    );
}

function ProductComponent({
    productOptionDetail,
    relatedProductOptionDetail,
    PURCHASE_ROUTE_OPTIONS,
    setViewType
}) {
    const purchaseInfosValueContextHook = usePurchaseInfosValueContextHook();
    const purchaseInfos = purchaseInfosValueContextHook.purchaseInfos;
    const createPurchaseInfoMutation = useCreatePurchaseInfoMutation();

    let targetPurchaseInfos = purchaseInfos?.filter(purchaseInfo => purchaseInfo.productOptionId === relatedProductOptionDetail?.productOptionDto?.id);
    // targetPurchaseInfos를 defaultFlag 우선순위 정렬
    targetPurchaseInfos = targetPurchaseInfos?.sort((a, b) => {
        if (a.defaultFlag && !b.defaultFlag) {
            return -1;
        } else if (!a.defaultFlag && b.defaultFlag) {
            return 1;
        } else {
            return 0;
        }
    });

    const handleReqCreateOne = async (purchaseInfo) => {
        const newPurchaseInfo = {
            ...purchaseInfo,
            uuid: uuidv4(),
            productOptionId: productOptionDetail?.productOptionDto?.id,
            defaultFlag: false
        }

        createPurchaseInfoMutation.mutate({
            body: {
                payload: newPurchaseInfo
            }
        }, {
            onSuccess: (data) => {
                // onClose();
                setViewType('DEFAULT');
            }
        })
    }

    return (
        <StyledProduct>
            <h4>{relatedProductOptionDetail?.productDto?.name} - {relatedProductOptionDetail?.productOptionDto?.name}</h4>
            <div className='purchase-infos'>
                {targetPurchaseInfos?.map(tpi => {
                    const purchaseRouteOption = PURCHASE_ROUTE_OPTIONS?.find(pro => pro.value === tpi.purchaseRoute);
                    return (
                        <div
                            key={tpi.uuid}
                            className="purchase-info"
                            onClick={() => handleReqCreateOne(tpi)}
                        >
                            <span className='badge memo'>{tpi.name}</span>
                            <span className='badge route'>{purchaseRouteOption.label}</span>
                            {tpi.defaultFlag &&
                                <span className='badge'># Default</span>
                            }
                        </div>
                    )
                })}
            </div>
        </StyledProduct>
    );
}